<template>
  <span>
    <filter-select id="taskSelect" ref="taskSelect" :placeholder="$t('task.name')" :multiple="false" @filter="itemSearch" :selected="selectedItem" @changed="itemSelected" />
  </span>
</template>

<script>
export default {
  props: ["selected"],
  data() {
    return {
      selectedItem: undefined,
    };
  },
  computed: {
    account() {
      return this.$store.getters["user/account"];
    },
  },
  watch: {
    selected: {
      immediate: true,
      handler(v) {
        this.selectedItem = v;
      },
    },
  },
  mounted() {},
  methods: {
    async itemSearch(value, callback) {
      const response = await this.$store.dispatch(`task/fetchLinkableTasks`, {
        options: { limit: 200 },
        query: { name: { value } },
      });
      callback(response.data?.docs ?? []);
    },

    itemSelected(item) {
      this.selectedItem = item;
      this.$emit("onSelect", item);
    },
  },
};
</script>

<style>
.multiselect-wrapper .multiselect__option--highlight {
  background: rgb(237, 237, 237) !important;
  color: black !important;
}
</style>
